import {
  Stack,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Menu,
  Modal,
} from "@mui/material";
import ClientIndustrial from "assets/client-industrial.png";
import Page from "components/Layout/Page/Page";
import { useEffect, useState, useMemo } from "react";
import { Add, Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { maskCpfCnpj, maskPhoneNumber } from "utils/Masks/Masks";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PasswordCheckList from "components/Feedback/PasswordCheckList/PasswordCheckList";
import { useConsigazApi } from "hooks/useConsigazApi";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import ClienteService from "../../services/cliente";
import HomeTemplate from "pages/HomeTemplate/HomeTemplate";
import NewCpfAccess from "./_fragments/NewCpfAcces";
import { LinkUnitsModal } from "./_fragments/LinkUnitsModal";
import ConsigazApi from "api/ConsigazApi";
import { AuthService } from "context/AuthContext/AuthContext";
import { IconPerson } from "components/Icons/IconPerson";
import { IconMoreVert } from "components/Icons/IconMoreVert";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";

export default function RegisterCpfAccess() {
  const router = useHistory();
  const history = useHistory();

  const localEntrega = ClienteService.localEntrega;

  const [currentStep, setCurrentStep] = useState("list"); // list, add
  const [list, setList] = useState([]);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editUser, setEditUser] = useState(null);
  const [changeStatusUser, setChangeStatusUser] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [isOpenConfirmPassword, setIsOpenConfirmPassword] = useState(false);
  const [isOpenLinkUnitsModal, setIsOpenLinkUnitsModal] = useState(false);
  const [unitsDraft, setUnitsDraft] = useState(null);

  const [selecterdToPassword, setSelectedToPassword] = useState(null);
  const [selectedToUnits, setSelectedToUnits] = useState(null);

  const [search, setSearch] = useState("");

  const filteredList = useMemo(() => {
    const term = search.trim().toLocaleLowerCase();
    if (!term) return list;

    const termDigits = term.replace(/\D/g, "");
    return list?.filter((user) => {
      const nome = user.nome?.toLocaleLowerCase() ?? "";
      const cpf = user.CPF ?? "";

      const matchNome = nome.includes(term);
      const matchCpf = termDigits.length > 0 && cpf.includes(termDigits);

      return matchNome || matchCpf;
    });
  }, [list, search]);

  const isMenuOpen = Boolean(menuAnchorEl);

  useEffect(() => {
    getList();
  }, [currentStep]);

  async function getList() {
    const response = await ConsigazApi.retornaAdmIndustrial(
      AuthService.getUserCpfLocalStorage(),
      localEntrega.CPFCNPJ
    );

    if (response) {
      setList(
        response?.administrador?.DadosAdministrador?.[0]?.DadosUsuarioComum
      );
    }
  }

  const handleMenuOpen = (event, user) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedUser(null);
  };

  const handleMenuAction = (action) => {
    if (action === "editar-usuario") {
      setEditUser(selectedUser);
      setCurrentStep("add");
    }

    if (action === "habilitar-cpf") {
      setChangeStatusUser(selectedUser);
    }

    if (action === "reenviar-senha") {
      setSelectedToPassword(selectedUser);
    }

    if (action === "unidades-acesso") {
      setSelectedToUnits(selectedUser);
      setUnitsDraft(null);
    }

    handleMenuClose();
  };

  async function handleSubmit(liberar, userdata, changePass) {
    setLoadingStatus(true);

    await ConsigazApi.cadastraUsuarioComum(
      {
        "cpf-adm": AuthService.getUserCpfLocalStorage(),
        CNPJ: localEntrega.CPFCNPJ,
        CPF: userdata.CPF.replace(/\D/g, ""),
        nome: userdata.nome,
        email: userdata.email,
        telefone: userdata.telefone.replace(/\D/g, ""),
        "enviar-senha": changePass ? "yes" : "no",
        "status-acesso": changePass
          ? userdata["status-acesso"] == "Liberado"
            ? "Liberado"
            : "Bloqueado"
          : liberar
          ? "Liberado"
          : "Bloqueado",
        DadosUsuarioComumLocais: [
          {
            "cpf-adm": AuthService.getUserCpfLocalStorage(),
            CNPJ: localEntrega.CPFCNPJ,
            CPF: userdata.CPF.replace(/\D/g, ""),
            "cod-entrega": "padrao",
          },
        ],
      },
      true
    )
      .then((data) => {
        if (data.retorno?.[0]?.situacao == "OK") {
          getList();
          if (changePass) {
            setIsOpenConfirmPassword(true);
          }
        }
      })
      .catch((e) => {
        e && toast.error(e);
      })
      .finally(() => {
        setChangeStatusUser(null);
        setSelectedToPassword(null);
        setLoadingStatus(false);
      });
  }

  if (currentStep === "add") {
    return (
      <NewCpfAccess
        onBack={() => {
          setCurrentStep("list");
          setEditUser(null);
        }}
        onSuccess={() => {
          setCurrentStep("list");
          setEditUser(null);
        }}
        editUser={editUser}
      />
    );
  }

  const currentUnitCodes =
    selectedToUnits?.DadosUsuarioComumLocais?.map((l) => l["Local-entrega"]) ??
    [];

  const effectiveUnitCodes = unitsDraft ?? currentUnitCodes;

  async function handleSaveUnits() {
    setLoadingStatus(true);

    const codesToAdd = effectiveUnitCodes.filter(
      (code) => !currentUnitCodes.includes(code)
    );
    const codesToRemove = currentUnitCodes.filter(
      (code) => !effectiveUnitCodes.includes(code)
    );

    try {
      if (codesToAdd.length > 0) {
        await ConsigazApi.cadastraUsuarioComum(
          {
            "cpf-adm": AuthService.getUserCpfLocalStorage(),
            CNPJ: localEntrega.CPFCNPJ,
            CPF: selectedToUnits.CPF,
            DadosUsuarioComumLocais: codesToAdd.map((code) => ({
              CPF: selectedToUnits.CPF,
              "cod-entrega": code,
            })),
          },
          false,
          codesToAdd
        );
      }

      if (codesToRemove.length > 0) {
        await ConsigazApi.removeLocalUsuarioComum({
          "cpf-adm": AuthService.getUserCpfLocalStorage(),
          CNPJ: localEntrega.CPFCNPJ,
          CPF: selectedToUnits.CPF,
          DadosUsuarioComumLocais: codesToRemove.map((code) => ({
            CPF: selectedToUnits.CPF,
            "cod-entrega": code,
          })),
        });
      }

      getList();
      setSelectedToUnits(null);
      setUnitsDraft(null);
    } catch (e) {
      e && toast.error(e);
    } finally {
      setLoadingStatus(false);
    }
  }

  return (
    <HomeTemplate
      className=""
      history={history}
      //   activeTab="Home"
    >
      <Stack sx={{ justifyContent: "center", alignItems: "center", mt: 4 }}>
        <Stack sx={{ maxWidth: "540px" }} width="100%">
          <Stack
            sx={{ flexDirection: "row", alignItems: "center" }}
            width={"100%"}
            gap={2}
          >
            <Typography
              fontSize={"18px"}
              fontWeight={700}
              textAlign={"left"}
              color="#636363"
            >
              Lista de CPF(s) com acesso a essa conta industrial
            </Typography>
            <Button
              sx={{
                bgcolor: "#2CABF9",
                fontWeight: 800,
                color: "#fff",
                gap: "8px",
                flexDirection: "row",
              }}
              onClick={() => setCurrentStep("add")}
            >
              <Add />
              Novo CPF
            </Button>
          </Stack>
          <TextField
            placeholder="Buscar por nome ou CPF..."
            variant="standard"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ mt: 2 }}
          />
          {/* LIST CPF */}
          <Stack width={"100%"} mt={"26px"} gap={"20px"}>
            {filteredList?.map((i, idx) => {
              const isMenuForItemOpen = selectedUser === i;

              return (
                <Stack
                  key={idx}
                  sx={{
                    width: "100%",
                    border: `solid 2px #053462`,
                    borderRadius: "8px",
                    flexDirection: "row",
                    gap: "24px",
                    alignItems: "center",
                    textAlign: "left",
                    position: "relative",
                  }}
                >
                  <Stack
                    sx={{
                      position: "absolute",
                      right: "24px",
                    }}
                  >
                    <IconButton
                      id={`cpf-menu-button-${idx}`}
                      aria-controls={isMenuForItemOpen ? "cpf-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={isMenuForItemOpen ? "true" : undefined}
                      onClick={(event) => handleMenuOpen(event, i)}
                    >
                      <IconMoreVert />
                    </IconButton>
                  </Stack>
                  <Stack
                    padding={"24px"}
                    sx={{
                      flexDirection: "row",
                      gap: "24px",
                      alignItems: "center",
                    }}
                  >
                    <IconPerson />
                    <Stack gap={"12px"}>
                      <Typography
                        fontWeight={"600"}
                        fontSize={"14px"}
                        sx={{ color: "#636363" }}
                      >
                        {maskCpfCnpj(i.CPF)}
                      </Typography>
                      <Typography
                        fontWeight={"600"}
                        fontSize={"18px"}
                        sx={{ color: "#053462" }}
                      >
                        {i.nome}
                      </Typography>
                      <Typography
                        fontWeight={"600"}
                        fontSize={"16px"}
                        sx={{ color: "#636363" }}
                      >
                        {(i.DadosUsuarioComumLocais?.length ?? 0) > 1
                          ? `${i.DadosUsuarioComumLocais?.length} unidades vinculadas`
                          : `${
                              i.DadosUsuarioComumLocais?.length ?? 0
                            } unidade vinculada`}
                      </Typography>

                      <Stack
                        sx={{
                          height: "21px",
                          bgcolor:
                            i["status-acesso"] == "Liberado"
                              ? "#44BB3D"
                              : "#DC3E31",
                          borderRadius: "16px",
                          px: "16px",
                          justifyItems: "center",
                          justifyContent: "center",
                          alignItems: "center",
                          fontSize: "11px",
                          color: "#fff",
                          fontWeight: 600,
                          width: "fit-content",
                        }}
                      >
                        {i["status-acesso"] == "Liberado"
                          ? "CPF HABILITADO"
                          : "CPF DESABILITADO"}
                      </Stack>
                    </Stack>
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
          <Menu
            id="cpf-menu"
            anchorEl={menuAnchorEl}
            open={isMenuOpen}
            onClose={handleMenuClose}
            MenuListProps={{
              "aria-labelledby": menuAnchorEl?.id,
            }}
            PaperProps={{
              sx: {
                border: "2px solid #053462",
                boxShadow: "0px 4px 12px rgba(5, 52, 98, 0.15)",
              },
            }}
            slotProps={{
              transition: {
                timeout: { enter: 0, exit: 0 },
              },
            }}
          >
            <MenuItem onClick={() => handleMenuAction("editar-usuario")}>
              <Typography
                fontWeight={"500"}
                fontSize={"14px"}
                sx={{
                  color: "#053462",
                }}
              >
                Editar usuário
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction("reenviar-senha")}>
              <Typography
                fontWeight={"500"}
                fontSize={"14px"}
                sx={{
                  color: "#053462",
                }}
              >
                Reenviar senha
              </Typography>
            </MenuItem>
            <MenuItem onClick={() => handleMenuAction("unidades-acesso")}>
              <Typography
                fontWeight={"500"}
                fontSize={"14px"}
                sx={{
                  color: "#053462",
                }}
              >
                Unidades de acesso
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (selectedUser?.["status-acesso"] === "Liberado") {
                  handleMenuAction("habilitar-cpf");
                } else {
                  handleSubmit(true, selectedUser, false);
                  handleMenuClose();
                }
              }}
            >
              {selectedUser?.["status-acesso"] === "Liberado" ? (
                <Typography
                  fontWeight={"500"}
                  fontSize={"14px"}
                  sx={{
                    color: "#C62128",
                  }}
                >
                  Desabilitar CPF
                </Typography>
              ) : (
                <Typography
                  fontWeight={"500"}
                  fontSize={"14px"}
                  sx={{
                    color: "#3BA83E",
                  }}
                >
                  Habilitar CPF
                </Typography>
              )}
            </MenuItem>
          </Menu>
        </Stack>
      </Stack>
      <Modal
        open={Boolean(changeStatusUser)}
        onClose={() => setChangeStatusUser(null)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"450px"}
          maxWidth={"450px"}
          style={{
            width: "450px",
            paddingBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          borderRadius={"8px"}
          px={"24px"}
        >
          <Stack p={"32px"}>
            <Typography
              fontSize={"24px"}
              fontWeight={600}
              color="#2CABF9"
              textAlign={"center"}
              lineHeight={"100%"}
            >
              Você tem certeza que deseja desabilitar o usuário?
            </Typography>
            <Typography
              fontSize={"14px"}
              fontWeight={500}
              color="#03172F"
              align="justify"
              lineHeight={"100%"}
              marginTop={"28px"}
              maxWidth={"386px"}
              textAlign={"center"}
            >
              Uma vez que o usuário seja desabilitado ele não poderá mas acessar
              o sistema da Consigaz usando esse CPF.
            </Typography>
          </Stack>
          <Stack
            maxWidth={"386px"}
            sx={{
              width: "100%",
              border: `solid 2px #053462`,
              borderRadius: "8px",
              padding: "24px",
              flexDirection: "row",
              gap: "24px",
              alignItems: "center",
            }}
          >
            <IconPerson />
            <Stack gap={"12px"}>
              <Typography
                fontWeight={"600"}
                fontSize={"14px"}
                sx={{ color: "#636363" }}
              >
                {changeStatusUser?.CPF}
              </Typography>
              <Typography
                fontWeight={"600"}
                fontSize={"18px"}
                sx={{ color: "#053462" }}
              >
                {changeStatusUser?.nome}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            width={"100%"}
            mt={"20px"}
          >
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                setChangeStatusUser(null);
              }}
            >
              CANCELAR
            </Button>
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                handleSubmit(false, changeStatusUser, false);
              }}
              loading={loadingStatus}
            >
              DESABILITAR USUÁRIO
            </Button>
          </Stack>
        </ContentModal>
      </Modal>
      <Modal
        open={Boolean(selectedToUnits)}
        onClose={() => setSelectedToUnits(null)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"450px"}
          maxWidth={"450px"}
          style={{
            width: "450px",
            paddingBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          borderRadius={"8px"}
          px={"24px"}
        >
          <Stack
            p={"26px"}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"flex-start"}
            alignItems={"flex-start"}
            width="100%"
          >
            <Typography
              fontSize={"14px"}
              fontWeight={700}
              color="#03172F"
              textAlign="left"
              lineHeight={"100%"}
              marginTop={"28px"}
              maxWidth={"386px"}
              width="100%"
            >
              Unidades vinculadas:
            </Typography>
          </Stack>
          <Stack
            maxWidth={"386px"}
            sx={{
              width: "100%",
              border: `solid 2px #053462`,
              borderRadius: "8px",
              padding: "24px",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <IconPerson />
            <Stack gap={"12px"}>
              <Typography
                fontWeight={"600"}
                fontSize={"14px"}
                sx={{ color: "#636363" }}
              >
                {maskCpfCnpj(selectedToUnits?.CPF)}
              </Typography>
              <Typography
                fontWeight={"600"}
                fontSize={"18px"}
                sx={{ color: "#053462" }}
              >
                {selectedToUnits?.nome}
              </Typography>
            </Stack>
          </Stack>
          {effectiveUnitCodes.map((code, idx) => {
            const endereco = localEntrega?.ClienteEntrRetorno?.find(
              (item) => item["local-entrega"] === code
            );

            return (
              <Stack
                key={idx}
                maxWidth={"386px"}
                sx={{
                  width: "100%",
                  mt: "12px",
                  border: `solid 1px #053462`,
                  borderRadius: "8px",
                  padding: "24px",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Stack gap={"12px"}>
                  <Typography
                    fontWeight={"600"}
                    fontSize={"18px"}
                    sx={{ color: "#053462" }}
                  >
                    {endereco?.endereco}
                  </Typography>
                  <Typography
                    fontWeight={"600"}
                    fontSize={"14px"}
                    sx={{ color: "#636363" }}
                  >
                    {endereco?.cidade}/{endereco?.estado}
                  </Typography>
                </Stack>
              </Stack>
            );
          })}
          <Stack
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            width={"100%"}
            mt={"20px"}
          >
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "14px",
              }}
              onClick={() => {
                setIsOpenLinkUnitsModal(true);
              }}
            >
              Editar
            </Button>
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#FFF",
                height: "44px",
                width: "167px",
                borderRadius: "36px",
                fontSize: "16px",
                bgcolor: "#2CABF9",
              }}
              onClick={() => {
                if (unitsDraft) {
                  handleSaveUnits();
                } else {
                  setSelectedToUnits(null);
                }
              }}
              loading={loadingStatus}
            >
              {unitsDraft ? "Salvar edição" : "Ok"}
            </Button>
          </Stack>
        </ContentModal>
      </Modal>
      <LinkUnitsModal
        open={isOpenLinkUnitsModal}
        onClose={() => setIsOpenLinkUnitsModal(false)}
        addresses={localEntrega?.ClienteEntrRetorno ?? []}
        onConfirm={(codes) => {
          setUnitsDraft(codes);
          setIsOpenLinkUnitsModal(false);
        }}
        initialSelected={currentUnitCodes}
      />
      <Modal
        open={Boolean(selecterdToPassword)}
        onClose={() => setSelectedToPassword(null)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"450px"}
          maxWidth={"450px"}
          style={{
            width: "450px",
            paddingBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          borderRadius={"8px"}
          px={"24px"}
        >
          <Stack p={"32px"}>
            <Typography
              fontSize={"24px"}
              fontWeight={600}
              color="#2CABF9"
              textAlign={"center"}
              lineHeight={"100%"}
            >
              Reenviar de senha
            </Typography>
            <Typography
              fontSize={"14px"}
              fontWeight={500}
              color="#03172F"
              align="justify"
              lineHeight={"100%"}
              marginTop={"28px"}
              maxWidth={"386px"}
              textAlign={"center"}
            >
              O usuário receberá no e-mail cadastrado as informações de como
              proceder com a ativação da senha para acessar o Portal Consigaz.
            </Typography>
          </Stack>
          <Stack
            maxWidth={"386px"}
            sx={{
              width: "100%",
              border: `solid 2px #053462`,
              borderRadius: "8px",
              padding: "24px",
              flexDirection: "row",
              gap: "24px",
              alignItems: "center",
            }}
          >
            <IconPerson />
            <Stack gap={"12px"}>
              <Typography
                fontWeight={"600"}
                fontSize={"18px"}
                sx={{ color: "#053462" }}
              >
                {selecterdToPassword?.nome}
              </Typography>
              <Typography
                fontWeight={"600"}
                fontSize={"14px"}
                sx={{ color: "#636363" }}
              >
                {selecterdToPassword?.email}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            width={"100%"}
            mt={"20px"}
          >
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                setSelectedToPassword(null);
              }}
            >
              CANCELAR
            </Button>
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                handleSubmit(false, selecterdToPassword, true);
              }}
              loading={loadingStatus}
            >
              REENVIAR SENHA
            </Button>
          </Stack>
        </ContentModal>
      </Modal>
      <Modal
        open={isOpenConfirmPassword}
        onClose={() => setIsOpenConfirmPassword(false)}
        disableAutoFocus={true}
      >
        <ContentModal
          minWidth={"450px"}
          maxWidth={"450px"}
          style={{
            width: "450px",
            paddingBottom: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          borderRadius={"8px"}
          px={"24px"}
        >
          <Stack p={"32px"}>
            <Typography
              fontSize={"24px"}
              fontWeight={600}
              color="#2CABF9"
              textAlign={"center"}
              lineHeight={"100%"}
            >
              Senha reenviada com sucesso!
            </Typography>
            <Typography
              fontSize={"14px"}
              fontWeight={500}
              color="#03172F"
              align="justify"
              lineHeight={"100%"}
              marginTop={"28px"}
              maxWidth={"386px"}
              textAlign={"center"}
            >
              O usuário receberá no e-mail cadastrado as informações de como
              proceder com a ativação da senha para acessar o Portal Consigaz.
            </Typography>
          </Stack>

          <Stack
            alignItems={"center"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            width={"100%"}
            mt={"20px"}
          >
            <div />
            <Button
              variant="text"
              color="secondary"
              sx={{
                color: "#2CABF9",
                height: "45px",
                borderRadius: "36px",
                fontSize: "18px",
              }}
              onClick={() => {
                setIsOpenConfirmPassword(false);
              }}
              loading={loadingStatus}
            >
              OK
            </Button>
          </Stack>
        </ContentModal>
      </Modal>
    </HomeTemplate>
  );
}
